<template>
	<div class="cog-section__placeholder" data-placeholder="true"></div>
</template>

<script>
	export default {};
</script>
